<template>
    <div class="componente" :style="{width: width, height:heigth, position: position, top:top, left:left }"
    
    :class="fondo"
    >
        <span>{{roundToX(valor)}} {{unidad}}</span>
      
    </div>
</template>
<script>
export default {
    data() {
        return {
            switch1:false,
        }
    },//fin data
    props:{
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,

        valor:Number,
        unidad:String
    },

    computed: {
       

        fondo(){
            let salida='';
           switch (this.valor) {
            case 0:
                salida='verde'
                break;
            case 1:
                salida='rojo'
                break;
            
            case 2:
                salida='amarillo'
                break;
           
            default:
                break;
           }

           return salida;
        }
    },

    methods: {
        roundToX(num, x = 2){ //Redondea a x decimales, por defecto a 2
            return +(Math.round(num + 'e+' + x) + 'e-' + x)
        }
    },
    
}
</script>
<style>
.componente{
    position: absolute;
   
}
.v-input--reverse .v-input__slot {
    flex-direction: row-reverse;
    justify-content: flex-end;

}

.verde{
    background-color: green !important;
}
.rojo{
    background-color: red!important;
}
.amarillo{
    background-color: yellow!important;

}
    
</style>